/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getDeleteOption, getUdiSectorName } from 'pgsse/util/PgsseUtil'
import Form from './form/Form'
import { useParams } from 'react-router'
import PgsseAction from 'pgsse/action/PgsseAction'
import { getLabel } from 'utils/StoreUtils'
import { isNil } from 'lodash'
import useActions from 'utils/customHook/useActions'
import { Box } from '@mui/material'
import PGSSEExport from '../common/PGSSEExport'
import { push } from '@lagunovsky/redux-react-router'
import { PGSSE_PHASE1_DIAGNOSTIC_FORM_DELETE } from 'aquaparc/AquaparcConstants'
import { sendStat } from 'aquaparc/AquaparcStatsSender'

const PgsseFormApp = ({
}) => {
    const dispatch = useDispatch()
    const { idDiagnostic, idForm } = useParams()

    const [isFormLoaded, setIsFormLoaded] = useState(false)
    const [isSurveyLoaded, setIsSurveyLoaded] = useState(false)
    const [readMode, setReadMode] = useState(true)
    const [isOpen, setIsOpen] = useState(false)
    const [form, setForm] = useState({})

    const {
        distributionUnits,
        sectors,
        diagnostic,
        form: propsForm,
        contributors,
        survey,
        accountUser,
    } = useSelector(store => ({
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnostic: store.PgsseReducer.diagnostic,
        form: store.PgsseReducer.form,
        contributors: store.ContributorReducer.contributors,
        survey: store.PgsseReducer.survey,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    useEffect(() => {
        setForm(propsForm)
    }, [propsForm])

    useEffect(() => {
        setIsFormLoaded(false)
        dispatch(PgsseAction.fetchForm(idForm)).then(() => setIsFormLoaded(true))
    }, [idForm])

    useEffect(() => {
        dispatch(PgsseAction.fetchDiagnostic(idDiagnostic))
    }, [idDiagnostic])

    useEffect(() => {
        if (!isNil(propsForm.idSurvey)) {
            setIsSurveyLoaded(false)
            dispatch(PgsseAction.fetchSurvey(propsForm.idSurvey, { stationType: propsForm.stationType }))
                .then(() => setIsSurveyLoaded(true))
        }
    }, [dispatch, propsForm])

    const onSave = ({ finaliseForm = false }) => {
        dispatch(PgsseAction.updateForm(form.idForm, {
            ...form,
            formStatus: finaliseForm || form.formStatus === 3 ? 3 : 2,
        })).then(() => {
            setReadMode(true)
        })
    }

    useTitle(() => {
        const udi = distributionUnits.find(du => du.id === diagnostic.idUdi)
        const sector = sectors.find(s => s.id === diagnostic.idSector)
        return [{
            title: i18n.pgsse,
            href: PATH_PGSSE,
        }, {
            title: i18n.phase1,
            href: `${PATH_PGSSE}/phase1`,
        }, {
            title: getUdiSectorName(udi, sector),
            href: `${PATH_PGSSE}/phase1/${diagnostic.idDiag}`,
        }, {
            title: getLabel(contributors, form.code),
            href: `${PATH_PGSSE}/phase1/${diagnostic.idDiag}/${idForm}`,
        }]
    }, [diagnostic, contributors])

    const onDelete = () => {
        sendStat(PGSSE_PHASE1_DIAGNOSTIC_FORM_DELETE)
        dispatch(PgsseAction.deleteForm(idForm)).then(() => {
            dispatch(push(`${PATH_PGSSE}/phase1/${diagnostic.idDiag}`))
        })
    }

    useActions(() => {
        return readMode ? {
            edit: () => setReadMode(false),
            exportList: [{
                onClick: () => setIsOpen(true),
                label: i18n.excel,
            }],
            ...getDeleteOption(accountUser, onDelete),
        } : {
            save: () => onSave({ finaliseForm: false }),
            cancel: () => {
                setForm(propsForm)
                setReadMode(true)
            },
        }
    }, [readMode, form, propsForm, accountUser])

    return (
        <Box sx={{ padding: '10 10 10 20' }}>
            <Form
                title={getLabel(contributors, form.code)}
                form={form}
                setForm={setForm}
                survey={survey}
                isFormLoaded={isFormLoaded}
                isSurveyLoaded={isSurveyLoaded}
                readMode={readMode}
                onSave={onSave}
            />
            <PGSSEExport
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                form={form}
                survey={survey}
                name={getLabel(contributors, form.code)}
            />
        </Box>
    )
}

PgsseFormApp.propTypes = {
}

export default PgsseFormApp
